<template>
  <div>
    <b-modal id="errorModal" title="Delete Confirmation" v-model="showErrorModal">
      <p class="text-danger">{{ errorMessage }}</p>
      <p>If you want to delete it, type <strong>DELETE</strong> and click Delete.</p>

      <b-form-input v-model="deleteInput" placeholder="Type DELETE to confirm" class="mt-2"></b-form-input>

      <template #modal-footer>
        <b-button variant="secondary" @click="showErrorModal = false">Cancel</b-button>
        <b-button variant="danger" :disabled="deleteInput !== 'DELETE'"
          @click="deleteSeminarMethod(deleteIndex, deleteId, true)">
          Delete
        </b-button>
      </template>
    </b-modal>

    <b-modal id="errorModal" title="Delete Confirmation" v-model="showParameterErrorModal">
      <p class="text-danger">{{ errorMessage }}</p>
      <p>If you want to delete it, type <strong>DELETE</strong> and click Delete.</p>

      <b-form-input v-model="deleteInput" placeholder="Type DELETE to confirm" class="mt-2"></b-form-input>

      <template #modal-footer>
        <b-button variant="secondary" @click="showParameterErrorModal = false">Cancel</b-button>
        <b-button variant="danger" :disabled="deleteInput !== 'DELETE'"
          @click="deleteParameter(deleteId, deleteIndex, deleteMethodIndex, true)">
          Delete
        </b-button>
      </template>
    </b-modal>

    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>


    <b-col class="addLab m-2">
      <b-card class="text-center mt-2">
        <!-- Button to add a new method -->
        <div class="d-flex justify-content-between align-items-center mt-2">
          <!-- Left: Add Method Button -->
          <b-button variant="info" @click="addMethod" class="d-flex align-items-center">
            <i class="fas fa-plus-square text-white mr-2"></i>
            Add methods for seminar evaluation
          </b-button>

          <!-- Right: Evaluate Component or Message -->
          <div>
            <template v-if="allMethodsSaved && hasMethodWithParameters">
              <seminar-evaluation :evaluationMethods="evaluationMethods" :course_id="course_id" />
            </template>
            <template v-else-if="allMethodsSaved">
              <p class="text-danger font-weight-bold mb-0">
                Add at least one evaluation method with parameters to update the score
              </p>
            </template>
          </div>
        </div>

        <table class="table table-striped table-bordered" >
          <thead class="thead-dark text-left">
            <tr>
              <th style="width: 5px;">SI. No.</th>
              <th>Method Name</th>
              <th></th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody class="text-left">
            <template v-for="(method, index) in evaluationMethods">
              <!-- Method Row -->
              <tr :key="`method-${method.id || index}`"
                v-if="methodExpandable === null || methodExpandable === method.id">
                <td>{{ index + 1 }}</td>
                <td>
                  <span v-if="method.saved">{{ method.name }}</span>
                  <div v-else class="d-flex flex-column">
                    <b-form-input :ref="'input' + index" v-model="method.name"
                      :class="{ 'form-group-error': $v.evaluationMethods.$each[index].name.$error }" placeholder="Enter method"
                      style="width: 400px;" @blur="$v.evaluationMethods.$each[index].name.$touch()"></b-form-input>
                    <span class="input-error-message"
                      v-if="$v.evaluationMethods.$each[index].name.$error && $v.evaluationMethods.$each[index].name.$dirty">
                      Method name is required!
                    </span>
                  </div>
                </td>
                <td>
                  <b-button v-if="method.saved && method.id" variant="link" class="ml-2"
                    @click="toggleParameterList(index, method)">
                    <i style="font-size: 12px!important; cursor: pointer;"
                      :class="method.showParameters ? 'fas fa-minus text-danger' : 'fas fa-plus text-success'"></i>
                    List of Parameters
                  </b-button>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <b-button v-if="!method.saved" variant="success" size="sm" class="mr-2"
                      @click="saveSeminarMethod(index)">
                      {{ method.id ? 'Update' : 'Save' }}
                    </b-button>
                    <b-button v-if="!method.saved" variant="danger" size="sm" class="mr-2"
                      @click="cancelSeminarMethod(index, method.id)">
                      Cancel
                    </b-button>
                    <i v-if="method.saved && method.id" class="far fa-edit text-info mr-2"
                      style="font-size: 14px; cursor: pointer;" @click="editSeminarMethod(index)"></i>
                    <i v-if="method.saved && method.id" class="fas fa-trash text-danger"
                      style="font-size: 14px; cursor: pointer;" @click="deleteSeminarMethod(index, method.id)"></i>
                  </div>
                </td>
              </tr>

              <!-- Parameters Row -->
              <tr v-if="method.showParameters && (methodExpandable === null || methodExpandable === method.id)"
                :key="`param-${method.id || index}`">
                <td colspan="4">
                  <SeminarMethodParameters :method="method" :methodIndex="index"
                    :courseOutcomeOptions="courseOutcomeOptions" @saveParameter="saveParameter"
                    @cancelParameter="cancelParameter" @deleteParameter="deleteParameter" @addParameter="addParameter"
                    :validation="$v.evaluationMethods.$each[index]" />
                </td>
              </tr>
            </template>
          </tbody>
        </table>

      </b-card>
    </b-col>





  </div>
</template>

<script>
import axios from "axios";
import Vue from 'vue'
import { required, helpers } from "vuelidate/lib/validators";
import SeminarMethodParameters from './SeminarMethodParameters.vue';
import SeminarEvaluation from './SeminarEvaluation.vue';
const decimalNumeric = helpers.regex('decimalNumeric', /^\d*(\.\d+)?$/);

export default {
  components: {
    SeminarMethodParameters,
    SeminarEvaluation
  },
  props: ["course_id"], // course_id passed as prop
  data() {
    return {
      viewImportExcelModel: false,
      importExcelFile: null,
      excelImportStatus: "",
      fetchData: false, // Loading state
      evaluationMethods: [], // Store evaluation methods
      methodExpandable: null, // Track which method's parameters to show
      courseOutcomeOptions: [], // Store available course outcomes
      evaluationTableHeaderRow: [],
      evaluationTableData: {},
      students: [],
      totalScores: {}, // processed on updateTotalMarks computed proprty
      avarage: {},
      updateSeminarEvaluationButton: "Save",
      errorMessage: '',
      showErrorModal: false,
      showParameterErrorModal: false,
      deleteInput: '',
      deleteId: null,
      deleteIndex: null,
      deleteMethodIndex: null,
    };
  },
  computed: {
    filteredEvaluationMethods() {
      return this.evaluationMethods.filter(
        method => this.methodExpandable === null || this.methodExpandable === method.id
      );
    },
    hasMethodWithParameters() {
      return this.evaluationMethods.some(method => method.parameters && method.parameters.length > 0);
    },
    allMethodsSaved() {
      return this.evaluationMethods.every(method => method.saved);
    }
  },
  validations: {
    evaluationMethods: {
      $each: {
        name: { required },
        parameters: {
          $each: {
            name: { required },
            maximum_score: {
              required,
              decimalNumeric
            }
          }
        },
      }
    }
  },
  async created() {
    this.fetchSeminarMethods(); // Fetch saved methods when component is created
    this.getcourseOutcomes(); // Fetch course outcomes when component is created
  },
  methods: {
    
    // Helper function to handle score values
    handleScoreValue(excelValue, institution_user_id, seminar_method_id, headerId) {
      this.$set(
        this.evaluationTableData[institution_user_id][seminar_method_id],
        headerId,
        parseFloat(excelValue)
      );
      this.updateTotalMarks(institution_user_id, seminar_method_id);
    },
    async fetchCourseStudents() {
      const url = this.$store.getters.getAPIKey.createStudent.replace("course_id", this.course_id);
      const response = await this.$axios.get(url);
      this.students = response.data[0] || [];
    },

    async seminarEvaluationTable() {
      this.evaluationTableHeaderRow = [];

      // Fetch students if not already loaded
      if (this.students.length === 0) await this.fetchCourseStudents();

      // Process evaluation methods and parameters
      this.evaluationMethods.forEach((method) => {
        let sum = 0;
        method.parameters.forEach((parameter) => {
          sum += Number(parameter.maximum_score);
          this.evaluationTableHeaderRow.push({
            id: parameter.id,
            name: parameter.name,
            seminar_method_id: method.id,
            max_score: parameter.maximum_score,
            cos: parameter.co_codes,
            type: null,
          });
        });
        // Add total row per method
        this.evaluationTableHeaderRow.push({
          id: null, name: 'Total', seminar_method_id: method.id, max_score: sum, cos: null, type: 'total'
        });
      });

      // Initialize evaluation table data
      this.students.forEach((student) => {
        Vue.set(this.evaluationTableData, student.institution_user_id, {});
        Vue.set(this.totalScores, student.institution_user_id, {});
        Vue.set(this.avarage, student.institution_user_id, {});

        this.evaluationTableHeaderRow.forEach((header) => {
          if (!this.evaluationTableData[student.institution_user_id][header.seminar_method_id]) {
            Vue.set(this.evaluationTableData[student.institution_user_id], header.seminar_method_id, {});
          }
          Vue.set(this.evaluationTableData[student.institution_user_id][header.seminar_method_id], header.id, null);
        });
      });

      this.$bvModal.show("seminarEvaluationModel");

      // Fetch existing evaluation scores
      const url = `${this.$store.getters.getAPIKey.mainAPI}/seminarevaluations/updateScore?course_id=${this.course_id}`;
      const response = await axios.get(url);
      response.data.forEach((evaluation) => {
        if (this.evaluationTableData[evaluation.student_id]) {
          this.evaluationTableData[evaluation.student_id][evaluation.seminar_method_id][evaluation.seminar_parameter_id] = parseFloat(evaluation.score);
          this.updateTotalMarks(evaluation.student_id, evaluation.seminar_method_id);
        }
      });

      this.$forceUpdate();
    },

    updateTotalMarks(student_id, seminar_method_id) {
      const scores = this.evaluationTableData[student_id][seminar_method_id];
      const total = Object.values(scores).reduce((sum, score) => sum + Number(score || 0), 0);
      this.totalScores[student_id][seminar_method_id] = total;

      const allTotals = Object.values(this.totalScores[student_id]).filter(score => score);
      this.avarage[student_id] = allTotals.length ? (allTotals.reduce((a, b) => a + b, 0) / allTotals.length).toFixed(2) : 0;
    },

    CloseSeminarEvaluationModel() {
      this.$bvModal.hide("seminarEvaluationModel");
    },

    async UpdateSeminarEvaluation() {
      const postData = [];

      Object.entries(this.evaluationTableData).forEach(([student_id, methods]) => {
        Object.entries(methods).forEach(([seminar_method_id, parameters]) => {
          Object.entries(parameters).forEach(([seminar_parameter_id, score]) => {
            if (score !== null) {
              postData.push({ score, course_id: this.course_id, student_id, seminar_method_id, seminar_parameter_id });
            }
          });
        });
      });

      try {
        await axios.post(`${this.$store.getters.getAPIKey.mainAPI}/seminarevaluations/updateScore`, { seminarEvaluations: postData });
        this.$toast.success("Successfully Updated", { position: "top", duration: 3000 });
      } catch (error) {
        this.$toast.error("Failed to create", { position: "top", duration: 3000 });
      }

      this.$bvModal.hide("seminarEvaluationModel");
    },
    // Fetch course outcomes for the given course
    async getcourseOutcomes() {
      const courseOutcomeUrl = this.$store.getters.getAPIKey.getCourseOutcomes;
      const url = courseOutcomeUrl.replace("course_id", this.course_id);
      await axios.get(url)
        .then((response) => {
          response.data.forEach(co => {
            this.courseOutcomeOptions.push({ value: co.id, text: co.code });
          });
        })
        .catch(error => {
          error;
        });
    },

    // Fetch saved Seminar evaluation methods from the API
    async fetchSeminarMethods() {
      this.fetchData = true;
      const url = `${this.$store.getters.getAPIKey.mainAPI}/seminarmethods?course_id=${this.course_id}`;

      try {
        const response = await axios.get(url);
        this.evaluationMethods = response.data.map((method) => ({
          id: method.id,
          name: method.name,
          parameters: method.seminar_parameters ?? [],
          saved: true,
          showParameters: false, // Initialize with hidden parameters
        }));
      } catch (error) {
        this.$toast.error("Failed to fetch evaluation methods", { position: "top", duration: 3000 });
      } finally {
        this.fetchData = false;
      }
    },

    // Add a new evaluation method
    addMethod() {
      this.methodExpandable = null;
      this.evaluationMethods.forEach(method => {
        method.showParameters = false;
      });
      const newIndex = this.evaluationMethods.length;
      this.evaluationMethods.push({ name: "", saved: false, id: null, showParameters: false, parameters: [] });
      this.$nextTick(() => {
        const inputRef = this.$refs['input' + newIndex];
        if (inputRef && inputRef[0]) {
          inputRef[0].focus();
        }
      });
    },

    // Save or update an evaluation method
    async saveSeminarMethod(index) {
      this.$v.evaluationMethods.$each[index].name.$touch();
      if (this.$v.evaluationMethods.$each[index].name.$invalid) {
        // Don't proceed, name is required
        return;
      }
      this.fetchData = true;
      const method = this.evaluationMethods[index];
      const url = `${this.$store.getters.getAPIKey.mainAPI}/seminarmethods${method.id ? '/' + method.id : ''}`;
      const requestType = method.id ? 'put' : 'post';

      try {
        const response = await axios[requestType](url, {
          course_id: this.course_id,
          name: method.name,
        });

        if (!method.id) {
          this.evaluationMethods[index].id = response.data.id; // Set ID for new method
        }
        this.evaluationMethods[index].saved = true; // Mark method as saved
        this.$toast.success(method.id ? "Updated successfully" : "Saved successfully", { position: "top", duration: 3000 });

      } catch (error) {
        this.$toast.error("Failed to save method, please try again", { position: "top", duration: 3000 });
      } finally {
        this.fetchData = false;
      }
    },

    // Edit an existing method (set to unsaved)
    editSeminarMethod(index) {
      const method = this.evaluationMethods[index];

      method._original = {
        name: method.name,
      };

      method.saved = false;

      this.$nextTick(() => {
        const inputRef = this.$refs['input' + index];
        if (inputRef && inputRef[0]) {
          inputRef[0].focus();
        }
      });
    },
    cancelSeminarMethod(index, methodId) {
      const method = this.evaluationMethods[index];

      // Reset validation state
      this.$v.evaluationMethods.$each[index].name.$reset();

      if (methodId) {
        if (method._original) {
          method.name = method._original.name;
          delete method._original;
        }
        method.saved = true;
      } else {
        // If it's a newly added method, just remove it
        this.evaluationMethods.splice(index, 1);
      }
    },
    cancelParameter(methodIndex, parameterIndex, parameterId) {
      this.$v.evaluationMethods.$each[methodIndex].parameters.$each[parameterIndex].$reset();
      const parameter = this.evaluationMethods[methodIndex].parameters[parameterIndex];

      if (parameterId) {
        // Restore original values
        if (parameter._original) {
          parameter.name = parameter._original.name;
          parameter.maximum_score = parameter._original.maximum_score;
          parameter.cos = [...parameter._original.cos];
          delete parameter._original;
        }
        parameter.isEditing = false;
      } else {
        // Remove unsaved parameter
        this.evaluationMethods[methodIndex].parameters.splice(parameterIndex, 1);
      }
    },
    async deleteSeminarMethod(index, id, forceDelete = false) {
      this.methodExpandable = null;
      this.evaluationMethods[index].showParameters = false;
      this.fetchData = true;

      let url = `${this.$store.getters.getAPIKey.mainAPI}/seminarmethods/${id}`;
      if (forceDelete) {
        url += '?forceDelete=1';
      }

      try {
        const response = await axios.delete(url);
        if (response.data === 1) {
          this.evaluationMethods.splice(index, 1);
          this.showErrorModal = false;
          this.$toast.success('Successfully Deleted', {
            position: "top",
            duration: 3000,
          });
        } else {
          this.errorMessage = "Cannot delete — this method is mapped to a parameter.";
          this.deleteId = id;
          this.deleteIndex = index;
          this.deleteInput = '';
          this.showErrorModal = true;
        }

      } catch (error) {
        error;

      } finally {
        this.fetchData = false;
      }
    },

    // Toggle the visibility of parameters
    toggleParameterList(index, method) {
      this.methodExpandable = this.methodExpandable === method.id ? null : method.id;
      method.showParameters = !method.showParameters;
      if(!method.showParameters){
        this.fetchSeminarMethods()
      }
    },
    addParameter(index) {
      this.evaluationMethods[index].parameters.push({
        name: "",
        isEditing: false // Set isEditing to false for the newly added parameter
      }); // Add empty parameter to the method
    },

    // Save or update a parameter for a method
    async saveParameter(methodIndex, paramIndex) {
      const validationParam = this.$v.evaluationMethods.$each[methodIndex].parameters.$each[paramIndex];

      // Touch both fields to show validation messages
      validationParam.name.$touch();
      validationParam.maximum_score.$touch();

      if (validationParam.name.$invalid || validationParam.maximum_score.$invalid) {
        return;
      }
      this.fetchData = true;
      const method = this.evaluationMethods[methodIndex];
      const parameter = method.parameters[paramIndex];
      const url = `${this.$store.getters.getAPIKey.mainAPI}/seminarparameters${parameter.id ? '/' + parameter.id : ''}`;
      const requestType = parameter.id ? 'put' : 'post';

      try {
        const response = await axios[requestType](url, {
          seminar_method_id: method.id,
          name: parameter.name,
          maximum_score: parameter.maximum_score,
          cos: parameter.cos,
        });
        this.evaluationMethods[methodIndex].parameters[paramIndex].isEditing = false;
        this.evaluationMethods[methodIndex].parameters[paramIndex].id = response.data.id;
        this.evaluationMethods[methodIndex].parameters[paramIndex].co_codes = response.data.course_outcomes.map((co) => co.code);
        this.$toast.success(parameter.id ? "Parameter updated successfully" : "Parameter saved successfully", { position: "top", duration: 3000 });
      } catch (error) {
        this.$toast.error("Failed to save parameter", { position: "top", duration: 3000 });
      } finally {
        this.fetchData = false;
      }
    },

    // Delete a parameter
    async deleteParameter(paramId, paramIndex, methodIndex, forceDelete = false) {
      if (!paramId) return;

      this.fetchData = true;

      let url = `${this.$store.getters.getAPIKey.mainAPI}/seminarparameters/${paramId}`;
      if (forceDelete) {
        url += '?forceDelete=1';
      }

      try {
        const response = await axios.delete(url);

        if (response.data === 1) {
          this.evaluationMethods[methodIndex].parameters.splice(paramIndex, 1);
          this.showParameterErrorModal = false;
          this.$toast.success('Successfully Deleted', {
            position: "top",
            duration: 3000,
          });
        } else {
          this.errorMessage = "Cannot delete — this parameter is mapped to a score update.";
          this.deleteId = paramId;
          this.deleteIndex = paramIndex;
          this.deleteMethodIndex = methodIndex;
          this.deleteInput = '';
          this.showParameterErrorModal = true;
        }

      } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
          this.$toast.error(error.response.data.message, { position: "top", duration: 3000 });
        } else {
          this.$toast.error("Failed to delete parameter", { position: "top", duration: 3000 });
        }
      } finally {
        this.fetchData = false;
      }
    },
  }
}
</script>
